import React from 'react'

const Loader = ({className=""}) => {
    return (
        <div className={`w-full text-center h-[50vh] flex items-center justify-center ${className}`}>
            {/* <div className="lds-hourglass"></div> */}
            <div className="loader"></div>
        </div>
    )
}

export default Loader
